
import { z } from "zod";

export const InvoiceStatusValues = ["PAID", "PARTIAL", "PENDING_APPROVAL", "REJECTED_INTERNALLY", "UNPAID", "VOIDED"] as const;
export const InvoiceStatusSchema = z.enum(InvoiceStatusValues);
export const InvoiceStatus = InvoiceStatusSchema.enum;
export type InvoiceStatus = (typeof InvoiceStatusValues)[number];
export const InvoiceStatusDisplayNames = { "PAID": "Paid",
"PARTIAL": "Partial",
"PENDING_APPROVAL": "Pending Approval",
"REJECTED_INTERNALLY": "Rejected Internally",
"UNPAID": "Unpaid",
"VOIDED": "Voided", } satisfies Record<InvoiceStatus, string>;
